import { render, staticRenderFns } from "./PaginaIndisponivel.vue?vue&type=template&id=b0779608&scoped=true"
import script from "./PaginaIndisponivel.vue?vue&type=script&lang=js"
export * from "./PaginaIndisponivel.vue?vue&type=script&lang=js"
import style0 from "./PaginaIndisponivel.vue?vue&type=style&index=0&id=b0779608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0779608",
  null
  
)

export default component.exports